import React, { useCallback, useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import './index.css'
import { sendCustomRequest } from '../../restClient'
import Layout from '../../layout'
import SuccessUnsubscribed from './success'
import SuccessSubscribed from './success-subscribe'
import ErrorUnsubscribed from './error'
import loader from './loader.svg'

const SubscribeForm = ({ match = {} }) => {
    const { params: { hash = null } = {} } = match
    const [loading, setLoading] = useState(true)
    const [content, setContent] = useState({})

    if (!hash) {
        setContent({
            type: 'error',
            name: 'error'
        })
    }

    const rollbackUnsubscribe = useCallback((hash) => {
        setLoading(true)
        return sendCustomRequest(`clients/email/subscribe/${hash}`)
            .then((response) => setResultMessage(response, 'subscribe'))
            .catch((response) => setResultMessage(response, 'subscribe'))
    }, [hash])

    const setResultMessage = useCallback((response, subscribe = false) => {
        setLoading(false)
        const isError = response instanceof Error && response.status !== 400

        if (isError) {
            setContent({
                type: 'error',
                name: 'error'
            })
            return
        }

        setContent({
            type: 'success',
            name: subscribe
        })
    }, [])

    useEffect(() => {
        if (hash) {
            setLoading(true)
            sendCustomRequest(`clients/email/unsubscribe/${hash}`)
                .then((response) => setResultMessage(response, 'unsubscribe'))
                .catch((response) => setResultMessage(response, 'unsubscribe'))
        }
    }, [hash])

    const Content = ({ content }) => {
        const { type = '', name = '' } = content

        switch (`${type}-${name}`) {
            case 'error-error':
                return (<ErrorUnsubscribed />)
            case 'success-unsubscribe':
                return (<SuccessUnsubscribed hash={hash} subscribe={rollbackUnsubscribe}/>)
            case 'success-subscribe':
                return (<SuccessSubscribed />)
            default:
                return null
        }
    }

    if (loading) {
        return (
            <Layout>
                <div className="layout-loading-box">
                    <img src={loader} className="layout-loading" alt="Loading" />
                </div>
            </Layout>
        )
    }

    return (
        <Layout>
            <div className="subscribe-template">
                <Content content={content}/>
            </div>
        </Layout>
    )
}

export default withRouter(SubscribeForm)



// WEBPACK FOOTER //
// ./src/components/subscribe/index.js